import React, { ReactElement } from 'react';
import './statements.less';
import Layout from './Layout';
import AnnualStatements from './AnnualStatements';
import MonthlyStatements from './MonthlyStatements';
import { Alert } from 'react-bootstrap';

export default function Statements(): ReactElement {
    return (
        <Layout section='statements'>
            <h1>Statements</h1>
            <Alert>
                <Alert.Heading>Annual Income Statement available now</Alert.Heading>
                <p>Your Annual Income Statements for the year ended 30 June 2026 are now available for you to download.</p>
            </Alert>
            <div className='statements'>
                <AnnualStatements />
                <MonthlyStatements />
            </div>
        </Layout>
    );
}
